import styled from "styled-components";
import { CircleButton } from "_c/button";

export const Wrap = styled.li`
  color: var(--font-color-accent);
  padding: 10px;
  display: flex;
  justify-content: space-between;
  position: relative;
  outline: none;
  border-bottom: ${({ theme }) => theme.border.light};
  :last-child {
    border-bottom: none;
  }
  @media (max-width: 550px) {
    flex-direction: column;
    justify-content: center;
    text-align: center;
    margin-bottom: 10px;
    margin-left: 0;
    padding: 10px;
  }
`;
export const TitleAndDiscountWrap = styled.div`
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  @media (max-width: 550px) {
    justify-content: center;
  }
`;
export const Title = styled.h3`
  color: var(--font-color-emp);
  margin-top: 0;
  font-size: 16px;
  font-weight: 500;
  margin-bottom: 0px;
  margin-inline-end: 15px;
  @media (max-width: 550px) {
    margin-inline-end: 0;
  }
`;
export const Price = styled.span`
  font-weight: 700;
  color: var(--color-cta);
`;
export const PriceUnitDelim = styled.span`
  color: var(--font-color-accent);
`;
export const Unit = styled.span`
  color: var(--font-color-accent);
`;
export const Duration = styled.span`
  display: flex;
  align-items: center;
  margin: 0 12px;
  color: var(--font-color-accent);
  span {
    margin-inline-start: 3px;
  }
`;
export const Info = styled.div`
  display: flex;
  align-items: center;
  font-size: 14px;
  font-weight: 700;
  margin-top: 5px;
  @media (max-width: 550px) {
    margin-top: 5px;
    margin-bottom: 10px;
    justify-content: center;
  }
`;
export const DescLabel = styled(CircleButton).attrs({
  primary: true,
  as: "span",
})`
  color: white;
  font-weight: 700;
  font-size: 15px;
  z-index: 5;
  cursor: help;
  user-select: none;
`;
export const ActiveDiscount = styled.span`
  width: 34px;
  height: 34px;
  background: ${({ model }) =>
    model ? "var(--color-primary)" : "var(--color-cta)"};
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 50%;
  color: white;
  font-size: 12px;
  font-weight: 700;
  cursor: help;
`;
